// src/components/admin/user/UserIndex.tsx

import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import UsersListPage from './UserListPage';
import UserForm from './UserForm';
import AboutSection from '../../AboutSection';
import UserRoleMappingList from '../userrolemapping/UserRoleMappingList';
import UserPermissionList from './UserPermissionList';

const isAdmin = true; // Replace with real auth logic

// Dynamic wrapper to map route to mode
const UserFormWrapper: React.FC = () => {
  const location = useLocation();
  const pathname = location.pathname;

  let mode: 'create' | 'edit' | 'view' = 'view';

  if (pathname.endsWith('/create')) mode = 'create';
  else if (pathname.endsWith('/edit')) mode = 'edit';

  console.log('🚀 Mode:', mode, 'Path:', pathname);

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col w-full p-2">
      <AboutSection title={`User - ${mode}`} iconName="users" />
      <UserForm mode={mode} />
    </div>
  );
};

export default function UsersModule() {
  if (!isAdmin) return <Navigate to="/unauthorized" />;

  return (
    <Routes>
      <Route index element={<UsersListPage />} />
      <Route path="create" element={<UserFormWrapper />} />
      <Route path=":id" element={<UserFormWrapper />} />
      <Route path=":id/edit" element={<UserFormWrapper />} />
      <Route path=":userId/roles" element={<UserRoleMappingList />} />
      <Route path=":userId/permissions" element={<UserPermissionList/>} />
    </Routes>
  );
}